import * as React from "react";
import { useTheme } from "@/hooks/useTheme";
import { withPrefix } from "@/lib/utils";

/**
 * Theme-aware GCPS wordmark logo, matching the pattern used in
 * src/components/app-sidebar.tsx so public pages match the authenticated
 * app's branding in both light and dark mode.
 */
export function OrgLogo({ className = "h-14" }: { className?: string }) {
	const { theme } = useTheme();
	const [logoType, setLogoType] = React.useState(theme);

	React.useEffect(() => {
		if (theme === "system") {
			const systemTheme = window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
			setLogoType(systemTheme);
			return;
		}

		setLogoType(theme);
	}, [theme]);

	return (
		<img
			src={
				logoType === "dark"
					? withPrefix("/assets/images/logo-ris-dark.png")
					: withPrefix("/assets/images/logo-ris.png")
			}
			alt="Ghana College of Physicians and Surgeons"
			className={className}
		/>
	);
}
